import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { MessageGroupSummary } from "../messageGroups.types";

interface RenameGroupModalProps {
  open: boolean;
  group?: MessageGroupSummary | null;
  isSaving?: boolean;
  errorMessage?: string | null;
  onClose: () => void;
  onConfirm: (payload: { name: string; avatar: string | null; description: string | null }) => Promise<void> | void;
}

export const RenameGroupModal = ({ open, group, isSaving, errorMessage, onClose, onConfirm }: RenameGroupModalProps) => {
  const [name, setName] = useState("");
  const [avatar, setAvatar] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!open) return;
    setName(group?.name ?? "");
    setAvatar(group?.avatar ?? "");
    setDescription(group?.description ?? "");
  }, [open, group?.name, group?.avatar, group?.description]);

  const handleConfirm = () =>
    onConfirm({ name: name.trim(), avatar: avatar.trim() || null, description: description.trim() || null });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth sx={{ zIndex: 2147483000 }}>
      <DialogTitle sx={{ pb: 1, fontSize: 17, fontWeight: 700 }}>Group details</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: "12px !important" }}>
        <TextField label="Group name" value={name} onChange={(event) => setName(event.target.value)} size="small" fullWidth autoFocus />
        <TextField label="Photo URL (optional)" value={avatar} onChange={(event) => setAvatar(event.target.value)} size="small" fullWidth />
        <TextField
          label="Description (optional)"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          size="small"
          fullWidth
          multiline
          minRows={2}
        />
        {errorMessage && <Typography sx={{ fontSize: 12, color: "error.main" }}>{errorMessage}</Typography>}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} size="small" color="inherit">
          Cancel
        </Button>
        <Button onClick={handleConfirm} size="small" variant="contained" disabled={!name.trim() || isSaving}>
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
